// Socket debugging utility to help troubleshoot notification issues
export const socketDebug = {
  // Enable debug mode
  enabled: false, // Disabled to reduce console noise

  log: (message: string, data?: any) => {
    if (socketDebug.enabled) {
      console.log(`🔌 [Socket Debug] ${message}`, data || '');
    }
  },

  // Test socket connection and events
  testSocketConnection: (socket: any, user: any) => {
    if (!socketDebug.enabled || !socket) return;

    socketDebug.log('Testing socket connection...');
    socketDebug.log('Socket connected:', socket.connected);
    socketDebug.log('Socket ID:', socket.id);
    socketDebug.log('Current user:', user?.id);

    // Test socket events
    socket.on('connect', () => {
      socketDebug.log('✅ Socket connected successfully');
    });

    socket.on('disconnect', (reason: string) => {
      socketDebug.log('❌ Socket disconnected:', reason);
    });

    socket.on('connect_error', (error: any) => {
      socketDebug.log('❌ Socket connection error:', error);
    });

    // Listen for bid events
    socket.on('bidPlaced', (data: any) => {
      socketDebug.log('🔔 Received bidPlaced event:', data);
    });

    socket.on('bid-placed', (data: any) => {
      socketDebug.log('🔔 Received bid-placed event:', data);
    });

    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off('connect_error');
      socket.off('bidPlaced');
      socket.off('bid-placed');
    };
  },

  // Test room joining
  testRoomJoining: (socket: any, itemId?: string, auctionId?: string) => {
    if (!socketDebug.enabled || !socket) return;

    if (itemId) {
      socketDebug.log(`Joining item room: item:${itemId}`);
      socket.emit('join:item', itemId);
    }

    if (auctionId) {
      socketDebug.log(`Joining auction room: auction:${auctionId}`);
      socket.emit('join-auction', auctionId);
    }
  },

  // Test notification system
  testNotificationSystem: (showNotification: any) => {
    if (!socketDebug.enabled) return;

    // Create a test notification
    const testNotification = {
      itemId: 'test-item-id',
      bid: {
        id: 'test-bid-id',
        user: {
          id: 'test-user-id',
          displayName: 'Test User',
          profileImageUrl: undefined,
        },
        item: {
          id: 'test-item-id',
          title: 'Test Item',
          images: [],
          imageUrl: undefined,
          mainImageIndex: 0,
        },
      },
      amount: 5000, // $50.00 in cents
      userId: 'test-user-id',
      item: {
        id: 'test-item-id',
        currentPrice: 5000,
        startPrice: 1000,
      },
    };

    socketDebug.log('Testing notification system with test data...');
    showNotification(testNotification);
  },
};
